import { RangeQuestion } from './RangeQuestion';
import { QuestionProps, YES_NO_OPTIONS, YesNoQuestionProps } from '../types';
import { ForwardedRef, forwardRef } from 'react';

type Props = QuestionProps<boolean> & YesNoQuestionProps;

export const YesNoQuestion = forwardRef((props: Props, ref: ForwardedRef<HTMLInputElement>) => (
  <RangeQuestion<boolean>
    {...props}
    options={YES_NO_OPTIONS}
    ref={ref as ForwardedRef<HTMLInputElement | HTMLSelectElement>}
  />
));
